import React, { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "./api";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined = checking
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cached = localStorage.getItem("bananax_admin_user");
    const token = localStorage.getItem("bananax_admin_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    if (cached) setUser(JSON.parse(cached));
    adminApi
      .get("/auth/me")
      .then((res) => {
        setUser(res.data);
        localStorage.setItem("bananax_admin_user", JSON.stringify(res.data));
      })
      .catch(() => {
        setUser(null);
        localStorage.removeItem("bananax_admin_token");
        localStorage.removeItem("bananax_admin_user");
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem("bananax_admin_token", data.token);
    localStorage.setItem("bananax_admin_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await adminApi.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("bananax_admin_token");
    localStorage.removeItem("bananax_admin_user");
    setUser(null);
  };

  return (
    <AdminAuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
};
